<template>
  <div class="py-2.5" :class="{'border-b border-gray-100': !last}">
    <div class="flex items-baseline gap-2">
      <span class="flex-1 text-[13px] font-semibold truncate">{{ name }}</span>
      <span class="text-[13px] font-bold shrink-0">{{ value }}</span>
    </div>
    <div class="flex items-center gap-2 mt-1.5">
      <div class="flex-1 h-[5px] rounded-full bg-gray-100 overflow-hidden">
        <div
          class="h-full rounded-full transition-all duration-500"
          :style="{width: `${Math.min(Math.max(pct, 0), 100)}%`, background: color || '#a78bfa'}"/>
      </div>
      <span v-if="sub" class="text-[11px] text-gray-500 shrink-0">{{ sub }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name: string;
  value: string;
  pct: number;
  sub?: string;
  color?: string;
  last?: boolean;
}>();
</script>
